var _class, _recentString, _recentInputTimer;

function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }

function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classPrivateFieldSet(receiver, privateMap, value) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set"); _classApplyDescriptorSet(receiver, descriptor, value); return value; }

function _classApplyDescriptorSet(receiver, descriptor, value) { if (descriptor.set) { descriptor.set.call(receiver, value); } else { if (!descriptor.writable) { throw new TypeError("attempted to set read only private field"); } descriptor.value = value; } }

function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get"); return _classApplyDescriptorGet(receiver, descriptor); }

function _classExtractFieldDescriptor(receiver, privateMap, action) { if (!privateMap.has(receiver)) { throw new TypeError("attempted to " + action + " private field on non-instance"); } return privateMap.get(receiver); }

function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

import { setComponentTemplate } from "@ember/component";
import { precompileTemplate } from "@ember/template-compilation";
import Component from '@glimmer/component';
import { svgJar } from '@cardstack/boxel/utils/svg-jar';
import BoxelDropdown from '../../dropdown';
import BoxelButton from '../../button';
import BoxelMenu from '../../menu';
import menuItem, { menuItemFunc } from '@cardstack/boxel/helpers/menu-item';
import registerElement from '@cardstack/boxel/modifiers/register-element';
import { action } from '@ember/object'; //@ts-expect-error glint does not think this is consumed-but it is consumed in the template https://github.com/typed-ember/glint/issues/374

import { fn, array, hash } from '@ember/helper';
import onKey from 'ember-keyboard/helpers/on-key';
import map from 'ember-composable-helpers/helpers/map';
import set from 'ember-set-helper/helpers/set';
import eq from 'ember-truth-helpers/helpers/eq';
import { registerDestructor } from '@ember/destroyable';
import { later } from '@ember/runloop';
import focusTrap from 'ember-focus-trap/modifiers/focus-trap';
import { NoneFocusKeyboardHandler, HourFocusKeyboardHandler, MinuteFocusKeyboardHandler, MeridianFocusKeyboardHandler } from './keyboard';
import '@cardstack/boxel/styles/global.css';
import './index.css';
let BoxelInputTime = setComponentTemplate(precompileTemplate(`
    <BoxelDropdown
      class="boxel-input-time"
      @contentClass="boxel-input-time__content"
      @registerAPI={{this.setDropdownAPI}}
      @onClose={{this.resetKeyboardFocus}}
      data-test-boxel-input-time
    >
      <:trigger as |bindings|>
        <BoxelButton
          {{bindings}}
          {{registerElement (set this 'triggerElement')}}
          class="boxel-input-time__trigger"
          data-test-boxel-input-time-trigger
          ...attributes
        >
          {{svgJar 'clock' class="boxel-input-time__icon" role="presentation"}}
          {{this.timeString}}
          {{svgJar "caret-down" class="boxel-input-time__caret" width=8 height=8 role="presentation"}}
        </BoxelButton>
      </:trigger>
      <:content>
        <div
          class="boxel-input-time__menu-container"
          {{registerElement (set this 'containerElement')}}
          {{focusTrap focusTrapOptions=(hash initialFocus=false)}}
        >
          {{onKey '_all' this.handleKeyboardEvent}}
          <BoxelMenu
            data-keyboard-focus="hour"
            data-test-boxel-hour-menu
            class="boxel-input-time__menu"
            tabindex="1"
            @items={{map (fn this.buildMenuItem this.hour this.setHour) this.hourOptions}}
            @itemClass="boxel-input-time__menu-item"
          />
          <BoxelMenu
            data-keyboard-focus="minute"
            data-test-boxel-minute-menu
            class="boxel-input-time__menu"
            tabindex="2"
            @items={{map (fn this.buildMenuItem this.minute this.setMinute) this.minuteOptions}}
            @itemClass="boxel-input-time__menu-item"
          />
          <BoxelMenu
            data-keyboard-focus="meridian"
            data-test-boxel-meridian-menu
            class="boxel-input-time__menu"
            tabindex="3"
            @items={{array
              (menuItem "am" (fn this.setMeridian 'am') selected=(eq this.meridian "am") tabindex=-1)
              (menuItem "pm" (fn this.setMeridian 'pm') selected=(eq this.meridian "pm") tabindex=-1)
            }}
            @itemClass="boxel-input-time__menu-item"
          />
        </div>
      </:content>
    </BoxelDropdown>
  `, {
  strictMode: true,
  scope: () => ({
    BoxelDropdown,
    BoxelButton,
    registerElement,
    set,
    svgJar,
    focusTrap,
    hash,
    onKey,
    BoxelMenu,
    map,
    fn,
    array,
    menuItem,
    eq
  })
}), (_class = (_recentString = /*#__PURE__*/new WeakMap(), _recentInputTimer = /*#__PURE__*/new WeakMap(), class BoxelInputTime extends Component {
  constructor(owner, args) {
    super(owner, args);

    _defineProperty(this, "dropdownAPI", void 0);

    _classPrivateFieldInitSpec(this, _recentString, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _recentInputTimer, {
      writable: true,
      value: void 0
    });

    _defineProperty(this, "containerElement", void 0);

    _defineProperty(this, "triggerElement", void 0);

    _defineProperty(this, "keyboardHandlers", void 0);

    this.validateMinuteInterval();
    this.keyboardHandlers = {
      none: new NoneFocusKeyboardHandler(this),
      hour: new HourFocusKeyboardHandler(this),
      minute: new MinuteFocusKeyboardHandler(this),
      meridian: new MeridianFocusKeyboardHandler(this)
    };
    registerDestructor(this, () => {
      _classPrivateFieldGet(this, _recentInputTimer)?.cancel?.();
    });
  }

  get minuteInterval() {
    this.validateMinuteInterval();
    return this.args.minuteInterval || 5;
  }

  get timeString() {
    return this.args.value?.toLocaleTimeString([], {
      hour: 'numeric',
      minute: 'numeric',
      timeZoneName: 'short'
    });
  }

  get hour() {
    return this.args.value ? this.args.value.getHours() % 12 : undefined;
  }

  get minute() {
    return this.args.value?.getMinutes();
  }

  get meridian() {
    if (this.args.value) {
      return this.args.value.getHours() < 12 ? 'am' : 'pm';
    }

    return undefined;
  }

  get hourOptions() {
    return [...Array(12).keys()].map(value => {
      return {
        value,
        display: value === 0 ? '12' : value.toString()
      };
    });
  }

  get minuteOptions() {
    return [...Array(60 / this.minuteInterval).keys()].map(n => n * this.minuteInterval).map(value => {
      return {
        value,
        display: (value < 10 ? '0' : '') + value.toString()
      };
    });
  }

  get keyboardFocus() {
    let focusedEl = document.activeElement;

    if (!focusedEl) {
      return 'none';
    }

    if (!focusedEl.hasAttribute('data-keyboard-focus')) {
      return 'none';
    }

    return focusedEl.getAttribute('data-keyboard-focus');
  }

  set keyboardFocus(val) {
    if (this.keyboardFocus !== val) {
      let targetEl = this.containerElement?.querySelector(`[data-keyboard-focus="${val}"]`);
      targetEl?.focus();
    }
  }

  setHour(hourNum) {
    let {
      value
    } = this.args;
    let effectiveDate = value ? new Date(value.getTime()) : new Date();

    if (effectiveDate.getHours() > 11) {
      hourNum = hourNum + 12;
    }

    let dateMs = effectiveDate.setHours(hourNum);
    this.args.onChange?.(new Date(dateMs));
  }

  setMinute(minuteNum) {
    minuteNum = Math.floor(minuteNum / this.minuteInterval) * this.minuteInterval; // round down to nearest interval

    let {
      value
    } = this.args;
    let effectiveDate = value ? new Date(value.getTime()) : new Date();
    let dateMs = effectiveDate.setMinutes(minuteNum);
    this.args.onChange?.(new Date(dateMs));
  }

  setMeridian(newMeridian) {
    if (this.meridian == newMeridian) {
      return;
    }

    let {
      value
    } = this.args;
    let effectiveDate = value ? new Date(value.getTime()) : new Date();
    let hourNum;

    if (newMeridian === 'am') {
      hourNum = effectiveDate.getHours() - 12;
    } else {
      hourNum = effectiveDate.getHours() + 12;
    }

    let dateMs = effectiveDate.setHours(hourNum);
    this.args.onChange?.(new Date(dateMs));
  }

  decrementHour() {
    if (this.hour === undefined) {
      this.setHour(11);
      return;
    }

    if (this.hour > 0) {
      this.setHour(this.hour - 1);
      return;
    }

    if (this.hour === 0) {
      this.setHour(11);
      this.toggleMeridian();
    }
  }

  incrementHour() {
    if (this.hour === undefined) {
      this.setHour(0);
      return;
    }

    if (this.hour < 11) {
      this.setHour(this.hour + 1);
      return;
    }

    if (this.hour === 11) {
      this.setHour(0);
      this.toggleMeridian();
    }
  }

  decrementMinute() {
    let highestValue = this.minuteOptions[this.minuteOptions.length - 1].value;

    if (this.minute === undefined) {
      this.setMinute(highestValue);
      return;
    }

    if (this.minute > 0) {
      this.setMinute(this.minute - this.minuteInterval);
      return;
    }

    if (this.minute === 0) {
      this.setMinute(highestValue);
    }
  }

  incrementMinute() {
    if (this.minute === undefined) {
      this.setMinute(0);
      return;
    }

    let highestValue = this.minuteOptions[this.minuteOptions.length - 1].value;

    if (this.minute < highestValue) {
      this.setMinute(this.minute + this.minuteInterval);
      return;
    }

    if (this.minute === highestValue) {
      this.setMinute(0);
    }
  }

  toggleMeridian() {
    if (this.meridian === 'pm' || this.meridian === undefined) {
      this.setMeridian('am');
    } else if (this.meridian === 'am') {
      this.setMeridian('pm');
    }
  }

  handleKeyboardEvent(ev) {
    this.keyboardHandlers[this.keyboardFocus].handle(ev);
  }

  updateHourFromNumericInput(numString) {
    if (_classPrivateFieldGet(this, _recentString)) {
      numString = `${_classPrivateFieldGet(this, _recentString)}${numString}`;
    }

    let hour = this.matchTimeOption(this.hourOptions, numString)?.value;

    if (hour !== undefined) {
      this.setHour(hour);
      this.setRecentInput(numString);
    }
  }

  updateMinuteFromNumericInput(numString) {
    if (_classPrivateFieldGet(this, _recentString)) {
      numString = `${_classPrivateFieldGet(this, _recentString)}${numString}`;
    }

    let minute = this.matchTimeOption(this.minuteOptions, numString)?.value;

    if (minute !== undefined) {
      this.setMinute(minute);
      this.setRecentInput(numString);
    }
  }

  clearRecentInput() {
    _classPrivateFieldSet(this, _recentString, undefined);

    _classPrivateFieldGet(this, _recentInputTimer)?.cancel?.();
  }

  setRecentInput(numString) {
    if (numString.length >= 2) {
      this.clearRecentInput();
      return;
    }

    _classPrivateFieldSet(this, _recentString, numString);

    _classPrivateFieldSet(this, _recentInputTimer, later(this, () => {
      _classPrivateFieldSet(this, _recentString, undefined);
    }, 2000));
  }

  matchTimeOption(options, numString) {
    // first try for an exact match
    let match = options.find(o => o.display === numString);

    if (match) {
      return match;
    } // otherwise match the shortest display text that starts with the specified text


    let matches = options.filter(o => o.display.startsWith(numString)).sort((a, b) => b.display.length - a.display.length);
    return matches[0];
  }

  buildMenuItem(selectedValue, onChoose, option) {
    return menuItemFunc([option.display, () => onChoose(option.value)], {
      selected: selectedValue === option.value,
      tabindex: -1
    });
  }

  setDropdownAPI(dropdownAPI) {
    this.dropdownAPI = dropdownAPI;
  }

  resetKeyboardFocus() {
    this.triggerElement?.focus();
  }

  validateMinuteInterval() {
    if (this.args.minuteInterval && 60 % this.args.minuteInterval !== 0) {
      throw new Error(`@minuteInterval passed to Boxel::Input::Time must be a factor of 60 but was ${this.args.minuteInterval}`);
    }
  }

}), (_applyDecoratedDescriptor(_class.prototype, "setHour", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setHour"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setMinute", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setMinute"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setMeridian", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setMeridian"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleKeyboardEvent", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleKeyboardEvent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "buildMenuItem", [action], Object.getOwnPropertyDescriptor(_class.prototype, "buildMenuItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setDropdownAPI", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setDropdownAPI"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetKeyboardFocus", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resetKeyboardFocus"), _class.prototype)), _class));
export { BoxelInputTime as default };